/* Что необходимо для открытия модального окна?
{
  component: AddTaxWindow,
  context: {},
};
*/

export const state = () => ({
  open: false,
  component: null,
  modalAction: null,
  context: {},
  error: null,

  nested: {
    open: false,
    component: null,
    modalAction: null,
    context: {},
    error: null,
  },
});

export const mutations = {
  open(state, { component, isNested = false }) {
    if (!isNested) {
      state.open = true;
      state.component = component;
    } else {
      state.nested.open = true;
      state.nested.component = component;
    }
  },
  close(state, isNested = false) {
    if (!isNested) {
      state.open = false;
      state.error = null;
    } else {
      state.nested.open = false;
      state.nested.error = null;
    }
  },
  setContext(state, { context, isNested = false }) {
    if (!isNested) {
      state.context = context;
    } else {
      state.nested.context = context;
    }
  },
  destroyComponent(state, isNested = false) {
    if (!isNested) {
      state.component = null;
    } else {
      state.nested.component = null;
    }
  },
  modalAction(state, action) {
    if (!action.isNested) {
      state.modalAction = action;
    } else {
      state.nested.modalAction = action;
    }
  },
  updateError(state, error) {
    if (!error.isNested) {
      state.error = error;
    } else {
      state.nested.error = error;
    }
  },
};

export const actions = {
  openModal({ commit }, payload) {
    commit('open', { component: payload.component, isNested: payload.isNested });
    commit('setContext', { context: payload.context, isNested: payload.isNested });
  },
  closeModal({ commit, state }) {
    const isNested = state.nested.open;
    commit('close', isNested);
    commit('destroyComponent', isNested);
    commit('setContext', { context: null, isNested });
  },
  setModalAction({ commit }, payload) {
    commit('modalAction', payload);
  },
  setModalError({ commit }, error) {
    commit('updateError', error);
  },
};

export const getters = {
  errorsList: (state) => {
    const errorsList = [];
    for (const elem in state.error) {
      state.error[elem].forEach((errorText) => errorsList.push(errorText));
    }
    return errorsList;
  },
  nestedErrorsList: (state) => {
    const errorsList = [];
    for (const elem in state.error) {
      state.nested.error[elem].forEach((errorText) => errorsList.push(errorText));
    }
    return errorsList;
  },
};

export default { namespaced: true, state, mutations, actions, getters };
